import { useContext } from "react";
import { useState, useEffect } from 'react';
import './authentication.css';
import { useQuery } from 'react-query';
import * as Api from '../../api/Api';
import * as KeyNames from '../../api/KeyNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import { GetURLParams } from '../../Components/Utils/Utils';
import { ChangePassword } from "./change-password";

export function ActivateAccount() {
    const resetToken = GetURLParams('a');
    const [resetData, setResetData] = useState(null);
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionData, resetToken ? resetToken : "NoToken"],
        async () => await Api.getResetPassword({ resetToken: resetToken }),
        {
            enabled: Boolean(resetToken)
        }
    );
    useEffect(() => {
        if (data) {

            if (data.success) {
                setResetData(data.data);
                //setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 103 });
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data, resetToken]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)


    return (
        <div>
              <div className='text-center mb-10'>
                <h1 className='text-dark mb-3'>Configurar nueva contraseña</h1>
                <div className="text-gray-400 fw-bold fs-4">Activa tu nueva contraseña</div>
            </div>
            {

                (resetData ? (
                    <ChangePassword resetToken={resetToken} />
                ) :
                    (
                        "Ha ocurrido un error. No es posible activar su cuenta.")
                )
            }
        </div>
    )
}
